import React, { createContext, useState, useContext } from "react";
import { requestTokenRefresh } from "../Api/Backend/Auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.warn("Failed to restore user data, clearing it.");
      localStorage.removeItem("user");
      return null;
    }
  });

  const login = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  const refreshAccessToken = async () => {
    if (!user?.refreshToken) {
      logout();
      return null;
    }

    const newToken = await requestTokenRefresh(user.refreshToken);
    if (!newToken) {
      logout();
      return null;
    }

    const updatedUser = {...user, accessToken: newToken}
    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));

    return newToken;
  };

  return (
    <AuthContext.Provider value={{ user, isLoggedIn: !!user, login, logout, refreshAccessToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 
